import store from  '../store'
export const waitForOrganization = ()=>{
    return new Promise((resolve, reject)=>{
        let i = 0;
        const _waitForOrganization = ()=>{
            if(Object(store.getState().currentOrganization).id){
                resolve(true)
            }else{
                if(i < 10){
                    i = i + 1
                    setTimeout(
                        _waitForOrganization
                    , 1000)
                }else{
                    reject('Never loaded organization')
                }
            }
        }
        _waitForOrganization()
    })
}


// WEBPACK FOOTER //
// ./src/actions/.helpers.js